import CheckBoxFilter from "@modules/new-explore/sidebar/filters/components/explore-checkbox";
import {
  ExploreBaseFilterSchema,
  ExploreDurationFilterSchema,
  ExploreFilterComponentProps,
} from "@modules/new-explore/types";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const ExploreDuration: React.FC<ExploreFilterComponentProps> = () => {
  const { filtersData } = useExplorePreloadedData();
  return (
    <CheckBoxFilter
      filterName="duration"
      item={
        (
          filtersData?.duration as ExploreBaseFilterSchema &
            ExploreDurationFilterSchema
        ).data
      }
    />
  );
};

export default ExploreDuration;
